import React, { useContext, useEffect, useState } from 'react';
import './Feedback.css'
import ThumbUpAltSharpIcon from "@mui/icons-material/ThumbUpAltSharp";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PeopleIcon from "@mui/icons-material/People";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import ButtonCompo from '../../Components/ButtonComponent/ButtonCompo';
import APIServices from '../../services/APIServices';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAccessToken } from '../../Redux/Actions';
import { EnvironmentContext } from '../../EnvironmentContext';
import apiconfig from '../../config/config';
import { DataGridComponent } from '../../Components/PaginationComponent';
import { Backdrop, CircularProgress } from '@mui/material';

const Feedback = () => {
    const { environment } = useContext(EnvironmentContext)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [organisersAverageRating, setOrganisersAverageRating] = useState([])
    const [MBTFeedbacks, setMBTFeedbacks] = useState([])
    const [allEventsFeedback, setAllEventsFeedback] = useState([])
    const accessToken = useSelector((state) => state.accessToken);
    const [reviewStatuses, setReviewStatuses] = useState({});
    const [finalCombinedData, setFinalCombinedData] = useState([])
    const [allReports, setAllReports] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const adminDetails = useSelector((state) => state?.loginUserDetails);

    const adminMail = adminDetails?.mail
    const testingEnvironmentIds = {
        "support@meetbytravel.com": "669f4adac194ae7c8eb65d50",
        "jayadeep.mettela@ro-one.in": "665d4b21e27fc43df3215575"
    };

    const productionEnvironmentIds = {
        "support@meetbytravel.com": "669f4b370e0130ee414ef469",
        "jayadeep.mettela@ro-one.in": "66750b795ec6ba4ed5e33656"
    };

    let adminUserId;
    if (environment === "Production") {
        adminUserId = productionEnvironmentIds[adminMail];
    } else if (environment === "Testing") {
        adminUserId = testingEnvironmentIds[adminMail];
    }


    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }
        if (accessToken || tokenLocal) {
            const tokenToUse = accessToken || tokenLocal;
            APIServices.setAuthToken(tokenToUse);
            setIsLoading(true)
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);
            APIServices.getOrganiserFeedback()
                .then((res) => {
                    const organisersFeedback = res?.data?.Feedbacks
                    setOrganisersAverageRating(organisersFeedback)
                    setIsLoading(false)
                })
                .catch((err) => {
                    console.log('Err in getting all  organisers feedbacks :', err)
                })

            APIServices.getMBTFeedback()
                .then((res) => {
                    const MBTFeedback = res?.data?.Feedbacks
                    setMBTFeedbacks(MBTFeedback);
                    setIsLoading(false)
                })
                .catch((err) => {
                    console.log('Err in getting mbt feedbacks :', err)
                })
            APIServices.getAllEventsFeedback()
                .then((res) => {
                    const eventsFeedback = res?.data?.Feedbacks
                    setAllEventsFeedback(eventsFeedback)
                    setIsLoading(false)

                })
                .catch((err) => {
                    console.log('Err in getting all events feedbacks :', err.response)
                })
        }


    }, [accessToken, dispatch, environment, navigate])

    useEffect(() => {
        const url = environment === "Production"
            ? apiconfig.production.apiBaseUrl
            : apiconfig.develpoment.apiBaseUrl;

        APIServices.setApiBaseUrl(url);
        APIServices.getAllReports(adminUserId)
            .then((res) => {
                setAllReports(res?.data?.Reports)
            })
            .catch((err) => {
                console.log('err in getting all reports :', err)
            })
    }, [environment, adminUserId])

    const combineFeedbacksAndRatings = (feedbacks, ratings, mbtFeedbacks) => {
        // Create a map of ratings with rated_by as the key
        const ratingsMap = new Map();
        ratings.forEach(rating => {
            ratingsMap.set(rating?.rated_by?._id, rating);
        });

        // Create a map of MBT feedbacks with user_id._id as the key
        const mbtFeedbacksMap = new Map();
        mbtFeedbacks.forEach(mbtFeedback => {
            mbtFeedbacksMap.set(mbtFeedback?.user_id?._id, mbtFeedback);
        });

        // Create a map of feedbacks with feedback_user_id._id as the key
        const feedbacksMap = new Map();
        feedbacks.forEach(feedback => {
            feedbacksMap.set(feedback.feedback_user_id._id, feedback);
        });


        const combinedArray = [];
        feedbacks.forEach(feedback => {
            const rating = ratingsMap.get(feedback?.feedback_user_id?._id);
            const mbtFeedback = mbtFeedbacksMap.get(feedback?.feedback_user_id?._id);
            combinedArray.push({
                ...feedback,
                ...rating,
                ...mbtFeedback,
                organiser_rating: rating ? rating?.organiser_rating : null,
                organiser_review: rating ? rating?.organiser_review : null,
                mbt_rating: mbtFeedback ? mbtFeedback?.mbt_rating : null,
                mbt_experience: mbtFeedback ? mbtFeedback?.mbt_experience : null,
                join_more_trips: mbtFeedback ? mbtFeedback?.join_more_trips : null,
                suggestions: mbtFeedback ? mbtFeedback?.suggestions : null,
            });
        });

        ratings.forEach(rating => {
            if (!feedbacksMap.has(rating.rated_by._id)) {
                const mbtFeedback = mbtFeedbacksMap.get(rating.rated_by._id);
                combinedArray.push({
                    rated_by: rating.rated_by,
                    feedback: null, // or any default value if feedback is missing
                    organiser_rating: rating.organiser_rating,
                    organiser_review: rating.organiser_review,
                    mbt_rating: mbtFeedback ? mbtFeedback.mbt_rating : null,
                    mbt_experience: mbtFeedback ? mbtFeedback.mbt_experience : null,
                    join_more_trips: mbtFeedback ? mbtFeedback.join_more_trips : null,
                    suggestions: mbtFeedback ? mbtFeedback.suggestions : null,
                });
            }
        });

        // Add all MBT feedbacks with their corresponding feedbacks if not already added
        mbtFeedbacks.forEach(mbtFeedback => {
            if (!feedbacksMap.has(mbtFeedback?.user_id?._id) && !ratingsMap.has(mbtFeedback?.user_id?._id)) {
                combinedArray.push({
                    user_id: mbtFeedback?.user_id?._id,
                    feedback: null, // or any default value if feedback is missing
                    organiser_rating: null,
                    organiser_review: null,
                    mbt_rating: mbtFeedback?.mbt_rating,
                    mbt_experience: mbtFeedback?.mbt_experience,
                    join_more_trips: mbtFeedback?.join_more_trips,
                    suggestions: mbtFeedback?.suggestions,
                });
            }
        });

        return combinedArray;
    };

    useEffect(() => {
        const combinedData = combineFeedbacksAndRatings(allEventsFeedback, organisersAverageRating, MBTFeedbacks);

        const initialReviewStatuses = {};
        combinedData?.forEach((event) => {
            initialReviewStatuses[event._id] = event?.feedback_event_id?.admin_approval || "Not Reviewed";
            // console.log("initialReviewStatuses :", initialReviewStatuses);
        });

        setReviewStatuses(initialReviewStatuses);
        setFinalCombinedData(combinedData);

        // console.log('combinedData :', combinedData);
    }, [allEventsFeedback, organisersAverageRating, MBTFeedbacks]);

    const ReviewStatusDropdown = ({ value, onChange }) => (
        <select className="text-black" value={value || "Not Reviewed"} onChange={onChange}>
            <option style={{ color: "#595959" }} value="Reviewed">Reviewed</option>
            <option style={{ color: "#595959" }} value="Not Reviewed">Not Reviewed</option>
        </select>
    );



    const handleReviewStatusChange = (event, id) => {
        const newStatus = event.target.value;
        setReviewStatuses((prevStatuses) => ({
            ...prevStatuses,
            [id]: newStatus,
        }));

        const eventObject = finalCombinedData.find((event) => event._id === id);
        console.log('event obj :', eventObject)

        if (!eventObject) {
            console.log("Event not found for ID:", id);
            return;
        }

        const body = {
            admin_approval: newStatus,
        };


        APIServices.eventReviewStatus(eventObject.feedback_event_id._id, body)
            .then((response) => {
                console.log('Review status updated successfully');
            })
            .catch((err) => {
                console.log("Error While Changing the Review Event Status: ", err);
            });
    };

    const handleViewButtonClick = (eventID, profileId) => {
        const profileWithID = finalCombinedData.filter(item => item?.feedback_event_id?.ID_event === eventID && item?.feedback_user_id?.profile_id === profileId);
        navigate(`/allfeedbacks/individual-feedback/${profileId}`, { state: { profileDetail: profileWithID } });
    }

    const columns = [
        {
            field: "eventID",
            headerName: "Event ID",
            width: 130,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
            renderCell: (params) => {
                const handleNavigate = () => {
                    // Collect all items with the same eventID
                    const eventsWithSameID = finalCombinedData.filter(item => item?.feedback_event_id?.ID_event === params?.value);
                    navigate(`eventfeedback/${params.value}`, { state: { events: eventsWithSameID } });
                };

                return (
                    <span
                        onClick={handleNavigate}
                        style={{ color: "blue", fontFamily: "Poppins", cursor: "pointer", textDecoration: "underline" }}
                    >
                        {params.value}
                    </span>
                );
            },

        },
        {
            field: "organiser",
            headerName: "Organiser",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
            renderCell: (params) => {
                const handleNavigate = () => {
                    const orgprofile = finalCombinedData.filter(item => item?.feedback_event_id?.organizers === params?.value)
                    const organiserID = params.row.organiserId
                    const reviewAsUser = finalCombinedData.filter(item =>
                        item.feedback_user_id?.profile_id === params.row.organiserId?.profile_id
                    )
                    console.log('reviewAsUser :', reviewAsUser)
                    navigate(`organiser-profile-feedback/${params?.row?.organiserId?.profile_id}`, { state: { orgprofile: orgprofile, organiserId: organiserID, reviewAsUser: reviewAsUser } });
                };

                return (
                    <span
                        onClick={handleNavigate}
                        style={{ color: "blue", fontFamily: "Poppins", cursor: "pointer", textDecoration: "underline" }}
                    >
                        {params.value}
                    </span>
                );
            },

        },
        {
            field: "profileID",
            headerName: "User profile ID",
            width: 130,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
            renderCell: (params) => {
                const handleNavigate = () => {
                    const profileWithSameID = finalCombinedData.filter(item => item?.feedback_user_id?.profile_id === params?.value);
                    navigate(`profilefeedback/${params.value}`, { state: { profile: profileWithSameID } });
                };

                return (
                    <span
                        onClick={handleNavigate}
                        style={{ color: "blue", fontFamily: "Poppins", cursor: "pointer", textDecoration: "underline" }}
                    >
                        {params.value}
                    </span>
                );
            },
        },
        {
            field: "fullName",
            headerName: "Full Name",
            width: 180,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "tripRating",
            headerName: "Trip Rating",
            width: 100,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "organiserRating",
            headerName: "Organiser Rating",
            width: 130,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "joinTrips",
            headerName: "Join Trips",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },

        {
            field: "reviewStatus",
            headerName: "Review Status",
            width: 150,
            cellClassName: "fullname-cell",
            headerClassName: "custom-header",
            renderCell: (params) => (
                <ReviewStatusDropdown
                    value={reviewStatuses[params.row.ids] || "Not Reviewed"}
                    onChange={(event) => handleReviewStatusChange(event, params.row.ids)}
                />
            ),
        },
        {
            width: 150,
            display: "flex",
            alignItems: "center",
            renderCell: (params) => (
                <ButtonCompo
                    btnOutlined
                    btnText="View"
                    onClick={() => handleViewButtonClick(params.row.eventID, params.row.profileID)}
                />
            ),
        },
    ];


    const rows = finalCombinedData?.map((item, index) => ({
        id: index,
        ids: item?._id,
        event: item?.feedback_event_id,
        eventID: item?.feedback_event_id?.ID_event,
        profileID: item?.feedback_user_id?.profile_id,
        fullName: item?.feedback_user_id?.firstName === null && item?.feedback_user_id?.lastName === null
            ? "Deleted Account"
            : `${item?.feedback_user_id?.firstName} ${item?.feedback_user_id?.lastName}`,
        tripRating: item?.event_rating,
        organiserRating: item?.organiser_rating,
        joinTrips: item?.join_more_trips,
        reviewStatus: item?.feedback_event_id?.admin_approval,
        organiser: item?.feedback_event_id?.organizers,
        organiserId: item?.organiser

    }));
    const sumOfRatings = organisersAverageRating.reduce((sum, eachOrgRating) => {
        return sum + eachOrgRating.organiser_rating;
    }, 0);
    const averageOrg = (sumOfRatings / organisersAverageRating.length).toFixed(2);

    const sumOfEventsRatings = allEventsFeedback.reduce((sum, eachEventRating) => {
        return sum + eachEventRating.event_rating;
    }, 0);

    const averageEvents = (sumOfEventsRatings / allEventsFeedback.length).toFixed(2);

    const getIconForExperience = (experience) => {
        switch (experience) {
            case "Security":
            case "Meet new people":
                return <Diversity3Icon />;
            case "Better locations":
            case "Amazing location":
                return <LocationOnIcon />;
            case "Flexibility of the trip":
                return <ShuffleIcon />;
            case "Itinerary":
            case "Matched Itinerary":
                return <PlaylistAddCheckIcon />;
            case "Organising":
            case "Friendly organiser":
                return <PeopleIcon />;
            case "Arrangements":
            case "Helpful trip arrangements":
                return <ThumbUpAltSharpIcon />;
            default:
                return null;
        }
    };

    // where we have to improve ...
    const experienceCounts = {
        "Security": 0,
        "Better locations": 0,
        "Flexibility of the trip": 0,
        "Itinerary": 0,
        "Organising": 0,
        "Arrangements": 0,
    };

    MBTFeedbacks.forEach(feedback => {
        feedback.mbt_experience.forEach(exp => {
            const trimmedExp = exp.trim(); // Trim whitespace from exp
            if (trimmedExp in experienceCounts) {
                experienceCounts[trimmedExp]++;
            }
        });
    });

    // for events , what enjoyed the most 
    const eventExperienceCounts = {
        "Meet new people": 0,
        "Amazing location": 0,
        "Flexibility of the trip": 0,
        "Matched Itinerary": 0,
        "Friendly organiser": 0,
        "Helpful trip arrangements": 0,
    };
    allEventsFeedback.forEach(feedback => {
        feedback.event_review.forEach(exp => {
            const trimmedExp = exp.trim(); // Trim whitespace from exp
            if (trimmedExp in eventExperienceCounts) {
                eventExperienceCounts[trimmedExp]++;
            }
        });
    });

    const columnsOfReports = [

        {
            field: "dateofReported",
            headerName: "Date of reported",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },

        {
            field: "fullName",
            headerName: "Full name",
            width: 180,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "email",
            headerName: "Email",
            width: 350,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "profile_id",
            headerName: "Profile ID",
            width: 140,

        },

        {
            field: "reportGiven",
            headerName: "Report",
            width: 350,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
    ];


    const rowsOfReports = allReports?.map((item, index) => ({
        id: index,
        ids: item?._id,
        dateofReported: item?.reported_at,
        profile_id: item?.user_id?.profile_id,
        fullName: item?.user_id?.firstName === null && item?.user_id?.lastName === null
            ? "Deleted Account"
            : `${item?.user_id?.firstName} ${item?.user_id?.lastName}`,
        reportGiven: item?.report,
        email: item?.user_id?.email === null ? "NA" : item?.user_id?.email
    }));

    return (
        <>
            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div>
                <div className="travellers-fed-container">
                    <div className="travellers-org">
                        <div className="travells-cont">
                            <p className="total-fed-para"> Total Feedbacks</p>
                            <h3 className="total-users-heading">
                                {organisersAverageRating.length}
                            </h3>

                        </div>
                    </div>

                    <div className="travellers-org">
                        <div className="travells-cont">
                            <p className="total-fed-para"> Overall trips Rating</p>
                            <h3 className="total-users-heading">
                                {averageEvents}
                            </h3>
                        </div>
                    </div>

                    <div className="travellers-org">
                        <div className="travells-cont">
                            <p className="total-fed-para"> Overall organiser Rating</p>
                            <h3 className="total-users-heading">
                                {averageOrg}
                            </h3>
                        </div>
                    </div>
                </div>

                <h3 className='enjoyed-text'>What enjoyed the most</h3>
                <br></br>
                <div className="heading-label-subdiv-feedback">
                    {Object.entries(eventExperienceCounts).map(([experience, count]) => (
                        <div key={experience} className='d-flex flex-column'>
                            <div className="icon-bg">
                                {getIconForExperience(experience)}
                                <p className="event-card-text">{experience}</p>
                            </div>
                            <p style={{ textAlign: 'center', color: 'blue', fontWeight: '600', fontFamily: 'poppins' }}>{count}</p>
                        </div>
                    ))}
                </div>

                <h3 className='enjoyed-text'>Areas to improve </h3>
                <br></br>
                <div className="heading-label-subdiv-feedback">
                    {Object.entries(experienceCounts).map(([experience, count]) => (
                        <div key={experience} className='d-flex flex-column'>
                            <div className="icon-bg">
                                {getIconForExperience(experience)}
                                <p className="event-card-text">{experience}</p>
                            </div>
                            <p style={{ textAlign: 'center', color: 'blue', fontWeight: '600', fontFamily: 'poppins' }}>{count}</p>
                        </div>
                    ))}
                </div>



                <div style={{ marginTop: '30px' }} >

                    {/* <Toolbar /> */}
                    <h3>Feedbacks ({finalCombinedData.length})</h3>
                    <div style={{ marginTop: '33px' }}>
                        <DataGridComponent columns={columns} rows={rows} />
                    </div>
                </div>


                <div style={{ marginTop: '30px' }} >
                    <h3>Reports ({allReports.length})</h3>
                    {/* <Toolbar /> */}
                    <div style={{ marginTop: '33px' }}>
                        <DataGridComponent columns={columnsOfReports} rows={rowsOfReports} rowCount={rowsOfReports.length} />
                    </div>

                </div>
            </div>

        </>

    )
}

export default Feedback